export default __webpack_public_path__ + "static/cf-logo-efedecbe18fc239072ce54c62a3df15f.svg";